import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import GameScene from './scenes/GameScene';
import UIScene from './scenes/UIScene';
import SplashScene from './scenes/SplashScene';
import HomeScene from './scenes/HomeScene';
import LeaderboardScene from './scenes/LeaderboardScene';
import { initIAP } from './IAPManager';

export default function PhaserGame() {
  const gameRef = useRef(null);

  useEffect(() => {
    if (gameRef.current) return;

    // Restore any prior IAP purchases (e.g. after reinstall)
    initIAP();

    import('@dimforge/rapier2d-compat').then(async (RAPIER) => {
      await RAPIER.init();
      window.__RAPIER__ = RAPIER;

      const dpr = window.devicePixelRatio || 1;
      const maxAspect = 9 / 16;
      const screenW = window.innerWidth;
      const screenH = window.innerHeight;
      const isLandscape = screenW / screenH > maxAspect;
      const gameW = isLandscape ? Math.floor(screenH * maxAspect) : screenW;

      const container = document.getElementById('phaser-container');
      if (isLandscape && container) {
        container.style.width = gameW + 'px';
        container.style.maxWidth = gameW + 'px';
      }

      const config = {
        type: Phaser.AUTO,
        parent: 'phaser-container',
        width: gameW * dpr,
        height: screenH * dpr,
        resolution: dpr,
        backgroundColor: '#a8d8f0',
        scene: [SplashScene, HomeScene, GameScene, UIScene, LeaderboardScene],
        scale: {
          mode: Phaser.Scale.FIT,
          autoCenter: Phaser.Scale.CENTER_BOTH,
          width: gameW * dpr,
          height: screenH * dpr,
        },
      };

      gameRef.current = new Phaser.Game(config);
    });

    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, []);

  return (
    <div
      id="phaser-container"
      style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}
    />
  );
}
